import { ResourceLanguage } from 'i18next'
import { Translation } from '../translation'

export const english: Translation & ResourceLanguage = {
    pageTitles: {
        coacheeLogin: 'Log into your account',
        redirecting: 'Redirecting…',
    },
    titles: {
        logIn: 'Sign in to Sama',
    },
    subTitles: {
        appDownload: 'or download the app',
    },
    buttons: {
        continue: 'Continue',
    },
    alt: {
        logo: 'Sama logo',
    },
    MagicLinkChooser: {
        title: 'How to continue?',
        openInApp: 'Continue on the Sama app',
        recommended: 'RECOMMENDED',
        continueOnWeb: 'Continue on this browser',
        continueToSama: 'Continue',
        linkExpiredError:
            'This sign-in link is no longer valid. It may have expired or already been used. Please request a new one from the login page.',
        downloadAppPrompt: "Don't have the app?",
        downloadAppCta: 'Get the Sama app',
        openingApp: 'Opening Sama app…',
        appNotDetected: 'App not detected. Redirecting to the store.',
        appStoreBadgeAlt: 'Download on the App Store',
        playStoreBadgeAlt: 'Get it on Google Play',
        alreadyUsedBadge: 'ALREADY USED',
        linkAlreadyUsedStatus: 'This sign-in link has been used.',
        secureNote: 'Secure, one-time sign-in link',
    },
}
